<template>
    <div>
        <ProjectServicesTop />
        <div class="mainTransportProducts">
            <div class="titleStyle">
                <div class="titleFont">{{ connectList.englishTitle }}</div>
                <div class="conentFont">
                    <div class="divide"></div>
                    <span class="enFont"
                        >FRONT DESK SYSTEM</span
                    >
                    <div class="divide"></div>
                </div>
            </div>
            <div class="mainTransportProductsContent">
                <div class="mainTransportProductsContentImg"></div>
                <div class="mainTransportProductsContentList">
                    <div
                        class="mainTransportProductsContentItem"
                        v-for="(item, idx) in connectList.cmsArticleList"
                        :key="idx"
                        v-show="idx < 3"
                        @mouseenter="changeImg(item, idx)"
                    >
                        <div class="itemTitle">{{ item.title }}</div>
                        <div class="itemContent">
                            {{ item.description }}
                        </div>
                        <div class="activeLine"></div>
                    </div>
                </div>
            </div>
        </div>
        <div class="transportation">
            <div class="titleStyle">
                <div class="titleFont">
                    {{ transportationList.englishTitle }}
                </div>
                <div class="conentFont">
                    <div class="divide"></div>
                    <span class="enFont">MIDDLE DESK SYSTEM</span>
                    <div class="divide"></div>
                </div>
            </div>
            <div class="transportationList">
                <div
                    v-for="(item, idx) in transportationList.cmsArticleList"
                    :key="idx"
                    class="transportationListItem"
                >
                    <div class="transportationListItemImg">
                        <img :src="item.image" />
                    </div>
                    <div class="transportationListTitle">
                        {{ item.title }}
                    </div>
                </div>
            </div>
        </div>
        <div class="supportPlatform">
            <div class="titleStyle">
                <div class="titleFont">后台系统</div>
                <div class="conentFont">
                    <div class="divide"></div>
                    <span class="enFont">BACKGROUND SYSTEM</span>
                    <div class="divide"></div>
                </div>
            </div>
            <div class="supportPlatformList">
                <div
                    class="supportPlatformItem"
                    v-for="(item, idx) in supportPlatformList.cmsArticleList"
                    :key="idx"
                >
                    <div class="itemImg">
                        <img :src="item.image" />
                    </div>
                    <div class="itemTitle">{{ item.title }}</div>
                    <div class="itemDesc">{{ item.description }}</div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import $ from "jquery";
import ProjectServicesTop from "@/components/ProjectServicesTop.vue";
import { getAction } from "@/api/services";
export default {
    name: "LogisticsNetwork",
    components: {
        ProjectServicesTop,
    },
    data() {
        return {
            url: "/jhwlweb/gwweb/cmsArticleCategory/queryServiceList",
            connectList: [],
            transportationList: [],
            supportPlatformList: [],
        };
    },
    created() {
        this.getInfo();
    },
    methods: {
        changeImg(item, idx) {
            $(".mainTransportProductsContentImg").css(
                "background-image",
                "url(" + item.image + ")"
            );
            $(".mainTransportProductsContentItem").removeClass(
                "mainTransportProductsContentItemAction"
            );
            $(".mainTransportProductsContentItem")
                .eq(idx)
                .addClass("mainTransportProductsContentItemAction");
        },
        getInfo() {
            let that = this;
            let parmas = {
                menuCategory: 10,
            };
            getAction(that.url, parmas).then((res) => {
                if (res.code == 200 && res.success) {
                    res.result.records.forEach((item, idx) => {
                        if (idx == 0) {
                            that.connectList = item;
                            $(".mainTransportProductsContentImg").css(
                                "background-image",
                                "url(" + item.cmsArticleList[0].image + ")"
                            );
                            setTimeout(() => {
                                $(".mainTransportProductsContentItem")
                                    .eq(0)
                                    .addClass(
                                        "mainTransportProductsContentItemAction"
                                    );
                            }, 10);
                        } else if (idx == 1) {
                            that.transportationList = item;
                        } else {
                            that.supportPlatformList = item;
                        }
                    });
                }
            });
        },
    },
};
</script>
<style lang="less" scoped>
.typeArea {
    max-width: 1100px;
    margin: 0 auto;
}
.bgSet {
    background-position: center center;
    background-size: cover;
    background-repeat: no-repeat;
}
.titleStyle {
    .typeArea();
    padding-bottom: 80px;
    padding-top: 90px;
    text-align: center;
    width: 100%;
    .titleFont {
        font-family: "阿里巴巴普惠体";
        font-size: 32px;
        line-height: 28px;
        letter-spacing: 2px;
        color: #333333;
    }
    .conentFont {
        margin-top: 8px;
        .divide {
            display: inline-block;
            vertical-align: super;
            width: 20px;
            height: 2px;
            background-color: #0052d9;
        }
        .enFont {
            margin: 0 10px;
            font-family: "微软雅黑";
            font-size: 16px;
            letter-spacing: 0px;
            color: #333333;
            opacity: 0.5;
        }
    }
}
.beyondOne {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
}
.mainTransportProducts {
    .typeArea();
    .describeFont {
        padding: 0 50px;
        font-size: 18px;
        letter-spacing: 0px;
        color: #333333;
        margin-bottom: 100px;
    }
    .mainTransportProductsContent {
        margin-bottom: 100px;
        .mainTransportProductsContentImg {
            width: 100%;
            height: 380px;
            .bgSet();
        }
        .mainTransportProductsContentList {
            display: flex;
            .mainTransportProductsContentItem {
                width: 100%;
                position: relative;
                padding: 40px 20px 60px;
                background-color: #f2f3f5;
                .itemTitle {
                    font-family: "优设标题黑";
                    font-size: 32px;
                    color: #333333;
                }
                .itemContent {
                    margin-top: 30px;
                    font-size: 14px;
                    color: #666666;
                }
                .activeLine {
                    display: none;
                    position: absolute;
                    left: 0;
                    bottom: 0;
                    width: 100%;
                    height: 4px;
                    background-color: #0052d9;
                }
            }
            .mainTransportProductsContentItemAction {
                background-color: #fbfbfb;
                .activeLine {
                    display: block;
                }
            }
        }
    }
}
.transportation {
    width: 100%;
    background: url("../../assets/zhongtaibg.jpg") no-repeat;
    padding-bottom: 70px;
    .titleStyle {
        .titleFont {
            color: #ffffff;
        }
        .conentFont {
            .enFont {
                color: #ffffff;
            }
        }
    }
    .transportationList {
        .typeArea();
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        .transportationListItem {
            width: calc(calc(100% - 60px) / 3);
            margin-top: 30px;
            .transportationListTitle {
                margin: 60px 0;
                text-align: center;
                font-size: 32px;
                font-family: "优设标题黑";
                font-weight: 400;
                color: #ffffff;
                line-height: 28px;
            }
            .transportationListItemImg {
                height: 100px;
                text-align: center;
                img {
                    width: 90px;
                    height: 90px;
                    max-width: 100%;
                    max-height: 100%;
                }
            }
        }
    }
}
.supportPlatform {
    background: url("../../assets/projectServices/backgrounSupport.png")
        no-repeat;
    height: 540px;
    .titleStyle {
        .titleFont {
            color: #ffffff;
        }
        .conentFont {
            .enFont {
                color: #ffffff;
            }
        }
    }
    .supportPlatformList {
        .typeArea();
        display: flex;
        justify-content: space-between;
        .supportPlatformItem {
            height: 242px;
            width: calc(calc(100% - 60px) / 4);
            box-shadow: 0px 2px 40px 0px rgba(0, 0, 0, 0.2);
            border-radius: 12px;
            border: 2px solid rgba(255, 255, 255, 0.6);
            display: flex;
            flex-wrap: wrap;
            justify-content: center;
            align-items: center;
            .itemImg {
                width: 50px;
                height: 50px;
                img {
                    height: auto;
                    width: auto;
                    max-height: 100%;
                    max-width: 100%;
                }
            }
            .itemTitle {
                text-align: center;
                font-size: 32px;
                font-family: "优设标题黑";
                font-weight: 400;
                color: #ffffff;
                line-height: 28px;
                width: 100%;
            }
            .itemDesc {
                display: none;
                text-align: center;
                width: 100%;
                font-size: 18px;
                font-weight: 400;
                color: #ffffff;
                line-height: 28px;
            }
        }
        .supportPlatformItem:hover {
            background: rgba(0, 82, 217, 0.6);
            .itemDesc {
                display: inline-block;
            }
        }
    }
}
</style>
